// Session-scoped threadId → ownerKey ("type:id") map. Unknown owners are
// treated as stale URLs (cross-mount leak, reload, foreign link).
const threadOwnership = new Map<string, string>();

export function getThreadOwner(threadId: string): string | undefined {
    return threadOwnership.get(threadId);
}

export function setThreadOwner(threadId: string, ownerKey: string): void {
    threadOwnership.set(threadId, ownerKey);
}

export function __getThreadOwnership(): Map<string, string> {
    return threadOwnership;
}

export function __resetThreadOwnership(): void {
    threadOwnership.clear();
}
